import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CSVService {

  constructor() { }

  /**
   * Método que realiza la exportación de datos a CSV
   * @param items Lista de datos
   * @param fileName Nombre del archivo
   */
  exportCSVFile(items: any[], fileName: string) {
    let paramCsvSeparator = '\t';
    this.createCSVFile(items, paramCsvSeparator, fileName);
  }

  /**
   * Metodo que crea el archivo para exportacion
   * @param items Lista de datos
   * @param csvSeparator Tipo de operador de separacion
   * @param fileName Nombre del archivo
   */
  createCSVFile(items: any[], csvSeparator: string, fileName: string) {
    // Escribe el fichero
    let jsonObject = JSON.stringify(items);

    let array = typeof jsonObject != 'object' ? JSON.parse(jsonObject) : jsonObject;
    let str = '';

    for (let i = 0; i < array.length; i++) {
      let line = '';
      for (let index in array[i]) {
        if (line != '') line += csvSeparator

        line += array[i][index] == '' ? '' : array[i][index] == null ? '' : array[i][index];
      }

      str += line + '\r\n';
    }

    // Descarga de fichero
    let encoding = "data:text/csv;charset=utf-8,%EF%BB%BF";

    let link = document.createElement("a");

    if (link.download !== undefined) {
      link.setAttribute("href", encoding + str);
      link.setAttribute("download", fileName + '.csv');
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
}
